export default {"src":"/_next/static/media/trash.83da484b.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};